import { getSkillRatio, getFlatSkillBonus } from './skillMod'
import * as Calc from './formulas'
import * as battleOption from './battleOptions'
import { defaultValue } from './entity'

export function getBattleDamage(
	baseDamage,
	source,
	target,
	skillName,
	skillLv,
) {
	let finalDamage = baseDamage

	if (battleOption.doesSkillUseMastery(skillName, skillLv)) {
		finalDamage += defaultValue(source?.Bonuses?.bMastery, 0)
	}
	if (
		battleOption.isSkillRanged(skillName, skillLv) ||
		battleOption.isWeaponRanged(source?.Inventory?.Right_Hand?.SubType)
	)
		finalDamage = Math.floor(
			finalDamage *
				(1 +
					(source?.Bonuses['bLongAtkRate']
						? source?.Bonuses['bLongAtkRate']
						: 0) /
						100),
		)
	else {
		// console.log(source)
		finalDamage = Math.floor(
			finalDamage *
				(1 +
					(source?.Bonuses['bShortAtkRate']
						? source?.Bonuses['bShortAtkRate']
						: 0) /
						100),
		)
	}
	finalDamage = applySkillRatio(
		finalDamage,
		getSkillRatio({ miscflag: 0 }, skillName, skillLv, source, target),
	)
	//console.log(source)

	if (skillName !== 'MO_EXTREMITYFIST')
		finalDamage = applyHardDef(
			finalDamage,
			Calc.getDefReduction(defaultValue(target?.Defense, 0)),
		)
	else finalDamage = applySoftDef(finalDamage, target.Defense)
	finalDamage = applySoftDef(finalDamage, target.SoftDefense)

	//Bonus type Skill damage + X %
	finalDamage = applyBonusSkillDamage(
		finalDamage,
		battleOption.getSkillDamageMultiplier(source?.Bonuses, skillName),
	)

	finalDamage += getFlatSkillBonus(0, source, target, skillName, skillLv)
	return Math.max(finalDamage, 1)
}

function applySkillRatio(damage, ratio) {
	return Math.floor((damage * ratio) / 100)
}
function applyHardDef(damage, defRatio) {
	return Math.floor(damage * defRatio)
}
function applySoftDef(damage, softDef) {
	return damage - softDef
}
function applyBonusSkillDamage(damage, bonus) {
	return Math.floor(damage * (1 + bonus / 100))
}
